export enum Language {
  Unknown,
  Swedish,
  English,
}
